import React, { useContext, useEffect, useState } from 'react';
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { axios, dataFetcher, endpoints, baseUrl, getToken } from 'Api';
import { AppContext, AuthContext } from 'Context';
import useSWR from 'swr';
import {
  List,
  ListItemButton,
  Collapse,
  ListItemText,
  Box,
  ListItemIcon,
} from '@mui/material';
import ExpandLess from '../../../../Assets/up-arrow.png';
import ExpandMore from '../../../../Assets/down.png';
import AppleIcon from '../../../../Assets/ApplePhotos.png';
import GoogleIcon from '../../../../Assets/GooglePhots.png';
import Pencil from '../../../../Assets/pencil.png';
import Styles from './sideBar.module.css';

const Sidebar = ({
  photosCount,
  setPhotosCount,
  videosCount,
  setVideosCount,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { category, albumid } = useParams();
  const { setAppSnackbar, setAlbumDetails, setCategoryDetails } = useContext(AppContext); 0;
  const [albumData, setAlbumData] = useState([]);
  const isVideosActive = location.pathname.startsWith('/storage/videos');
  const [open, setOpen] = React.useState(isVideosActive);
  const isPhotosActive = location.pathname.startsWith('/storage/photos');
  const [openPhotos, setOpenPhotos] = useState(isPhotosActive);

  // Keep open state in sync with route

  const [categrory, setCategrory] = useState([]);
  const fetchCategories = async () => {
    try {
      const token = getToken(); // Get the token
      const response = await axios.post(
        `${baseUrl}/${endpoints.getMyCategories}`,
        {}, // Empty body for the POST request
        {
          headers: {
            Authorization: `Bearer ${token}`, // Token in Authorization header
          },
        }
      );
      // Check if the response is successful
      if (response?.data?.success) {
        setCategrory(
          response?.data?.data?.map(({ title: name, id: value, user_id }) => ({
            name,
            value,
            user_id,
          }))
        );
        // eslint-disable-next-line
      } else {
        console.error('Failed to fetch categories:', response.data.message);
        return [];
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  };
    const { isValidating: gettingAlbums, mutate: getAlbums } = useSWR(
    [endpoints.getMyAlbum, 50, 0], // pass limit as a payload
    {
      fetcher: (url, limit, page) => dataFetcher(url, { limit, start: 0 }),
      onSuccess: ({ success, data, itemcount }) => {
        if (success) {
          setAlbumData(data);
        } else {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message: 'Oops! Something went wrong while fetching your photo albums',
          });
        }
      },
      onError: () => {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong while fetching your photo albums'
        });
      },
    }
  );
  useEffect(() => {
    fetchCategories();
    getAlbums();
  }, []);

  const handleClickCollapse = () => {
    setOpen(!open);
  };
    const handleClickPhotos = () => {
    setOpenPhotos(!openPhotos);
  };
  useEffect(() => {
    if (categrory?.length > 0) {
      setOpen(isVideosActive);
    }
    if (albumData?.length > 0) {
      setOpenPhotos(isPhotosActive);
    }
  }, [isVideosActive, isPhotosActive]);

  return (
    <div className={Styles.main}>
      <div className={Styles.mainX}>
        <div className={Styles.first}>
          <h5>Your Projector Gallery</h5>
          <ul className="!px-[12px]">
            <li>
              <NavLink
                style={{
                  background: location.pathname.startsWith('/storage/videos')
                    ? '#D6EBF8'
                    : '',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 12px',
                  fontFamily: 'Montserrat, sans-serif',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
                to="/storage/videos"
                onClick={handleClickCollapse}
              >
                <span>Videos</span>

                <Box
                  component="img"
                  src={open ? ExpandLess : ExpandMore}
                  alt="toggle"
                  sx={{ width: 12, height: 12 }}
                />
              </NavLink>

              <Collapse in={open} timeout="auto">
                {categrory?.map((obj, index) => (
                  <List
                    component="div"
                    disablePadding
                    key={index}
                    onClick={() => {
                      setCategoryDetails(obj);
                      navigate(`/storage/videos/${obj.value}`);
                    }}
                  >
                    <ListItemButton
                      sx={{
                        justifyContent: 'center',
                        pr: 2,
                        borderRadius: '12px',
                        backgroundColor:
                          category === obj.value
                            ? '#EDF7FD'
                            : 'transparent',
                      }}
                    >

                      <ListItemText
                        primary={obj.name || 'Uploaded Videos'}
                        primaryTypographyProps={{
                          sx: {
                            fontFamily: 'Montserrat, sans-serif',
                            textAlign: 'left',
                            color: 'inherit',
                            marginLeft: '10px',
                          },
                        }}
                      />
                    </ListItemButton>
                  </List>
                ))}
              </Collapse>
            </li>
            <li>
              {/* <NavLink to="/storage/photos"> */}
                <NavLink
                style={{
                  background: location.pathname.startsWith('/storage/photos')
                    ? '#D6EBF8'
                    : '',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 12px',
                  fontFamily: 'Montserrat, sans-serif',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
                to="/storage/photos"
               onClick={handleClickPhotos}
                >
                Photos
                {photosCount > 0 && <div>{photosCount}</div>}
                 <Box
                  component="img"
                  src={open ? ExpandLess : ExpandMore}
                  alt="toggle"
                  sx={{ width: 12, height: 12 }}
                 />
                </NavLink>
                            <Collapse in={openPhotos} timeout="auto" unmountOnExit>
                {albumData?.map((obj, index) => (
                  <List
                    component="div"
                    disablePadding
                    key={index}
                    onClick={() => {
                      setAlbumDetails(obj);
                      navigate(`/storage/photos/${obj?.id}`);
                    }}
                  >
                    <ListItemButton
                      sx={{
                        justifyContent: 'center',
                        pr: 2,
                        borderRadius: '12px',
                        backgroundColor:
                          albumid === obj.id
                            ? '#EDF7FD'
                            : 'transparent',
                      }}
                    >

                      <ListItemText
                        primary={obj.title || 'Uploaded Album'}
                        primaryTypographyProps={{
                          sx: {
                            fontFamily: 'Montserrat, sans-serif',
                            textAlign: 'left',
                            color: 'inherit',
                            marginLeft: '10px',
                          },
                        }}
                      />
                    </ListItemButton>
                  </List>
                ))}
                            </Collapse>
            </li>
          </ul>
        </div>

        <hr className={Styles.horizontalLine} />
        <div
          onKeyPress={undefined}
          role="button"
          tabIndex={0}
          onClick={() => window.open(
              'https://www.projectoruploader.com/download.html'
            )}
          className={Styles.fifth}
        >
          <h5>Connected Sources</h5>
          <span className={Styles.local}>Local</span>
        </div>
        <hr className={Styles.horizontalLine} />
        <div
          role="button"
          onKeyPress={undefined}
          tabIndex={0}
          className={Styles.fifth}
        >
          <h5>Cloud</h5>
          <button className={Styles.addSuccessorBtn}>
            <span className={Styles.local}>Connect Cloud Drive</span>
          </button>
          <div
            role="button"
            onKeyPress={undefined}
            tabIndex={0}
            className={Styles.fifthBtnGrp}
          >
            <Link to="/storage/google-photos">
              <img src={GoogleIcon} alt="" />
              Google Photos
            </Link>
            <div
              role="button"
              onKeyPress={undefined}
              className={Styles.applex}
              tabIndex={0}
              onClick={() => window.open('https://www.projectoruploader.com/download.html')}

            >
              <img src={AppleIcon} alt="" width="21" height="21" />
              Apple Photos
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
